import { Navigate, Outlet, useLocation } from 'react-router';

import { useSession } from './use-session';

/**
 * Gate for everything behind the login screen.
 *
 * While `/me` is still in flight nothing is rendered — showing the dashboard
 * and then yanking it away, or bouncing to login and back, is worse than a
 * blank moment.
 */
export default function RequireAuth() {
  const { status } = useSession();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="flex min-h-svh items-center justify-center bg-page">
        <span className="font-mono text-md tracking-widest text-ink-muted uppercase">
          Checking session…
        </span>
      </div>
    );
  }

  if (status === 'anonymous') {
    // `from` sends them back where they were aiming once they are through.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
